'use strict';

module.exports = {
  inputDebounceValue: 500,
  popupTimeout: 6000,
  ruleSetPopupTimeout: 2000,
  productCountLimit: 2500,
  excelRowLimit: 40000,
};
